import { AxiosCharts } from '../config';
import qs from 'qs';

const ChartService = {
  getCorretivas: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/quantidade-ocorrencias-por-status',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  getPrioridades: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/ocorrencias-por-prioridade-por-periodo',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  getRanking: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim, top = 20 }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/quantidade-ocorrencias-por-unidade-por-status',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
        top,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  getPreventivas: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/quantidade-atividades-por-status',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  getAvaliacaoAtendimento: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/quantidade-ocorrencias-por-status-avaliacao',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  getLocais: ({ Empresa, Sites, Cidade, Estado, GrupoSite, SubGrupoSite, Sistemas, Inicio, Fim }) => {
    return AxiosCharts({
      url: '/api/v1/DashBoard/atendimento-por-unidade',
      method: 'GET',
      params: {
        Empresa,
        Sites,
        Cidade,
        Estado,
        GrupoSite,
        SubGrupoSite,
        Sistemas: Sistemas?.map(s => s),
        Inicio,
        Fim,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
};
export { ChartService };
